export enum ScenarioType {
    PRO = 0,
    OIP = 1,
}